import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { toast as reactToast, ToastContent, ToastOptions } from 'react-toastify'
import { getErrors } from 'core/helpers'

const defaultSettings: ToastOptions = {
    position: 'top-right',
    autoClose: 4000,
    icon: false,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true
}

export const toast = {
    success(content: ToastContent, options?: ToastOptions | undefined, link?: JSX.Element) {
        reactToast.success(
            <>
                <FontAwesomeIcon icon={['fas', 'check-circle']} />
                &nbsp;{content}
                &nbsp;{link}
            </>
            , {
                ...defaultSettings,
                ...options
            })
    },

    error(content: ToastContent, options?: ToastOptions | undefined) {
        //prevent duplicates if toast id is supplied
        if (options && options.toastId && reactToast.isActive(options.toastId))
            return

        reactToast.error(
            <><FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />&nbsp;{content}</>
            , {
                ...defaultSettings,
                ...options
            })
    },

    errors(errors: Array<string>, options?: ToastOptions | undefined) {
        //prevent duplicates if toast id is supplied
        if (options && options.toastId && reactToast.isActive(options.toastId))
            return

        reactToast.error(
            <>
                <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} /> Errors
                <ul>
                    {errors.map(e => <li key={1}>{e}</li>)}
                </ul>
            </>
            , {
                ...defaultSettings,
                ...options
            })
    },

    responseErrors(response: unknown, options?: ToastOptions | undefined) {
        const errors = getErrors(response)
        reactToast.error(
            <>
                <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} /> Response Errors
                <ul>
                    {errors.map(e => <li key={1}>{e}</li>)}
                </ul>
            </>
            , {
                ...defaultSettings,
                ...options
            })
    },

    info(content: ToastContent, options?: ToastOptions | undefined) {
        reactToast.info(
            <><FontAwesomeIcon icon={['fas', 'info-circle']} />&nbsp;{content}</>
            , {
                ...defaultSettings,
                ...options
            })
    },

    warn(content: ToastContent, options?: ToastOptions | undefined) {
        reactToast.warn(
            <><FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />&nbsp;{content}</>
            , {
                ...defaultSettings,
                ...options
            })
    }
}

export default toast